import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import _ from 'lodash';

import {
    EmvioValidatedForm,
    EmvioValidatedInput,
    EmvioValidatedTextArea,
    EmvioButton,
    EmvioSelect,
    EmvioButton as Button
} from '@nexio/emvio-form-components';
import { EmvioLoadingSpinner as LoadingSpinner } from '@nexio/emvio-util-ui';
import Modal from '../../Modal/Modal';
import { submitPrevetForm, resetPrevetForm, submitPrevetFormLoading, onSubmitEditPrevetForm, updatePrevetFormLoading } from './prevetFormActions';
import { toggleModal } from '../../Modal/modalActions';
import {
    getIsPrevetFormSubmitting,
    getPrevetFormError,
    getPrevetFormSubmitSuccess,
    getPrevetFormPrevetId,
    getIsPrevetFormUpdateLoading,
    getPrevetFormUpdateError,
    getIsPrevetFormUpdateSuccess,
    getPrevetFormUpdatePrevetId
} from './prevetFormEntity';
import { getPrevet as fetchPrevet } from '../prevetActions';
import { getPrevetEntity } from '../prevetEntity';
import { goToUrl } from '../../Table/tableActions';
import imgInfoIcon from '../../../images/tooltip.svg';
import './PrevetForm.scss';

const MAX_FILE_SIZE_LIMIT = 4718592; // 4.5 MB
const MAX_FILES_LIMIT = 10;
const MAX_PAYLOAD_SIZE_LIMIT = 4718592; // 4.5 MB

const FULFILLMENT_TIMEFRAME_OPTIONS = [
    { value: '1-15', label: '1-15' },
    { value: '15-30', label: '15-30' },
    { value: '30-90', label: '30-90' },
    { value: '90-180', label: '90-180' },
    { value: '180-365', label: '180-365' }
];

const SUBSCRIPTION_OPTIONS = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' }
];

export class PrevetForm extends Component {
    static propTypes = {
        isSubmitting: PropTypes.bool,
        error: PropTypes.string,
        submitSuccess: PropTypes.bool,
        prevetId: PropTypes.number,
        updatedPrevetId: PropTypes.number,
        prevet: PropTypes.object,
        onSubmitEditPrevetForm: PropTypes.func,
        onSubmitForm: PropTypes.func.isRequired,
        onToggleModal: PropTypes.func,
        onResetForm: PropTypes.func,
        onFetchPrevet: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        isEditMode: PropTypes.bool,
        initialValues: PropTypes.object,
        showInModal: PropTypes.bool,
        modalTitle: PropTypes.string,
        uniqueModalName: PropTypes.string
    };

    static defaultProps = {
        isEditMode: false,
        showInModal: true,
        modalTitle: 'Pre-Vet Form',
        uniqueModalName: 'prevetForm'
    };

    constructor(props) {
        super(props);

        const initialValues = props.initialValues || {};

        this.state = {
            legalBusinessName: initialValues.legalName || initialValues.businessName || '',
            websiteUrl: initialValues.websiteUrl || initialValues.webAddress || '',
            businessDescription: initialValues.description || initialValues.businessDescription || initialValues.productsServicesOffered || '',
            expectedMonthlyVolume: initialValues.monthlyVolume || '',
            ticketSize: initialValues.ticketSize || initialValues.averageSalesAmount || '',
            fulfillmentTimeframe: initialValues.fulfillmentPeriod || initialValues.fulfillmentTimeframe || '',
            subscriptionRecurring: initialValues.doesRecurringBilling || '',
            yearsInBusiness: initialValues.yearsInBusiness !== null && initialValues.yearsInBusiness !== undefined ? String(initialValues.yearsInBusiness) : '',
            // hasBeenOnMatch: initialValues.hasBeenOnMatch || '',
            additionalNotes: initialValues.additionalNotes || initialValues.notes || '',
            supportingDocuments: initialValues.supportingDocuments || [],
            businessDescriptionFocused: false,
            additionalNotesFocused: false,
            websiteUrlValid: true
        };

        this.dropzoneRef = React.createRef();
        this.pollingInterval = null;
        this.pollingStartTime = null;
        this.isPolling = false;
        this.MAX_POLLING_DURATION = 120000; // 2 minutes
        this.POLLING_INTERVAL = 10000; // 10 seconds
        this.initialFormState = null;
    }

    componentWillUnmount() {
        this.stopPolling();
    }

    stopPolling = () => {
        this.isPolling = false;
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
        this.pollingStartTime = null;
    };

    // Handle polling for prevet status updates
    startPolling = (prevetId) => {
        this.stopPolling();
        this.isPolling = true;
        this.pollingStartTime = Date.now();

        this.pollingInterval = setInterval(() => {

            if (!this.isPolling) {
                return;
            }

            const elapsed = Date.now() - this.pollingStartTime;

            if (elapsed >= this.MAX_POLLING_DURATION) {
                this.stopPolling();
                toast.error('Prevet processing timed out. Please try again later.');
                if (this.props.onToggleModal) {
                    this.props.onToggleModal(this.props.uniqueModalName);
                }
                if (this.props.onResetForm) {
                    this.props.onResetForm();
                }

                return;
            }

            if (this.isPolling) {
                this.props.onFetchPrevet(prevetId);
            }
        }, this.POLLING_INTERVAL);

        // Initial poll to getPrevet by prevetId
        if (this.isPolling) {
            this.props.onFetchPrevet(prevetId);
        }
    };

    // Check the status of the prevet processing and handle the teminal states
    handlePrevetStatus = (prevet) => {
        const status = prevet?.status;

        if (status === 'completed' || status === 'errored') {
            this.stopPolling();
        }

        if (status === 'completed') {
            if (this.props.onToggleModal) {
                this.props.onToggleModal(this.props.uniqueModalName);
            }
            if (this.props.onResetForm) {
                this.props.onResetForm();
            }
            // Redirect to merchant/prevet detail page
            goToUrl(this.props.history, `/merchantdetails/${prevet.onboardingId}`);
        } else if (status === 'errored') {
            toast.error('Prevet processing failed. Please try again later.');
            if (this.props.onToggleModal) {
                this.props.onToggleModal(this.props.uniqueModalName);
            }
            if (this.props.onResetForm) {
                this.props.onResetForm();
            }
        }
    };

    componentDidUpdate(prevProps) {
        // Start polling when createPrevet succeeds
        if (!prevProps.submitSuccess && this.props.submitSuccess && !this.props.isEditMode) {
            if (this.props.prevetId) {
                this.startPolling(this.props.prevetId);
            } else {
                toast.error('Prevet creation failed. Please try again later.');
                if (this.props.onToggleModal) {
                    this.props.onToggleModal(this.props.uniqueModalName);
                }
                if (this.props.onResetForm) {
                    this.props.onResetForm();
                }
            }
        }

        if (this.props.submitSuccess && !this.props.isEditMode && this.props.isSubmitting && this.isPolling) {
            const prevPrevet = prevProps.prevet;
            const currentPrevet = this.props.prevet;

            // Only handle status if prevet exists, has an id and status changed
            if (currentPrevet && currentPrevet.id && currentPrevet.status &&
                (!prevPrevet || !prevPrevet.id || prevPrevet.status !== currentPrevet.status)) {
                this.handlePrevetStatus(currentPrevet);
            }
        }

        // Start polling when updatePrevet succeeds in edit mode, check when UpdatedPrevetId becomes available
        if (this.props.isEditMode && !prevProps.updatedPrevetId && this.props.updatedPrevetId && !this.isPolling) {
            this.startPolling(this.props.updatedPrevetId);
        }

        // Handle status changes during polling for edit mode and redirect to merchant details page
        if (this.props.isEditMode && this.isPolling) {
            const prevPrevet = prevProps.prevet;
            const currentPrevet = this.props.prevet;

            if (currentPrevet && currentPrevet.id && currentPrevet.status &&
                (!prevPrevet || !prevPrevet.id || prevPrevet.status !== currentPrevet.status)) {
                this.handlePrevetStatus(currentPrevet);
            }
        }

        if (!prevProps.error && this.props.error) {
            const errorMessage = typeof this.props.error === 'string'
                ? this.props.error
                : this.props.error?.message || 'Please try again later.';
            toast.error(`Failed to submit form: ${errorMessage}`);
            this.stopPolling();
        }

        //handles initialValues change in edit mode
        if (this.props.isEditMode && prevProps.initialValues !== this.props.initialValues && this.props.initialValues) {
            this.populateFormFromInitialValues();
        }
    }

    populateFormFromInitialValues = () => {
        const initialValues = this.props.initialValues || {};
        const formState = {
            legalBusinessName: initialValues.legalName || initialValues.businessName || initialValues.legalBusinessName || '',
            websiteUrl: initialValues.websiteUrl || initialValues.webAddress || '',
            businessDescription: initialValues.description || initialValues.businessDescription || initialValues.productsServicesOffered || '',
            expectedMonthlyVolume: initialValues.monthlyVolume || '',
            ticketSize: initialValues.ticketSize || initialValues.averageSalesAmount || '',
            fulfillmentTimeframe: initialValues.fulfillmentPeriod || initialValues.fulfillmentTimeframe || '',
            subscriptionRecurring: initialValues.doesRecurringBilling || '',
            yearsInBusiness: initialValues.yearsInBusiness !== null && initialValues.yearsInBusiness !== undefined ? String(initialValues.yearsInBusiness) : '',
            // hasBeenOnMatch: initialValues.hasBeenOnMatch || '',
            additionalNotes: initialValues.additionalNotes || initialValues.notes || '',
            supportingDocuments: initialValues.supportingDocuments || []
        };

        //store initial form state to detect changes in edit mode
        this.initialFormState = { ...formState };

        this.setState(formState);
    };

    handleModalOpen = () => {
        if (this.props.isEditMode) {
            this.populateFormFromInitialValues();
        } else {
            this.setState({
                legalBusinessName: '',
                websiteUrl: '',
                businessDescription: '',
                expectedMonthlyVolume: '',
                ticketSize: '',
                fulfillmentTimeframe: '',
                subscriptionRecurring: '',
                yearsInBusiness: '',
                // hasBeenOnMatch: '',
                additionalNotes: '',
                supportingDocuments: [],
                businessDescriptionFocused: false,
                additionalNotesFocused: false,
                websiteUrlValid: true
            });
        }
    };

    handleInputChange = (field) => (e) => {
        this.setState({
            [field]: e.target.value
        });
    };

    handleWebsiteUrlChange = (e) => {
        let value = e.target.value.trim();

        if (value === '') {
            this.setState({
                websiteUrl: '',
                websiteUrlValid: true
            });

            return;
        }

        value = value.replace(/^https?:\/\//, '');

        value = value.replace(/\/+$/, '');

        const isValid = this.validateWebsiteUrl(value);

        this.setState({
            websiteUrl: value,
            websiteUrlValid: isValid
        });
    };

    validateWebsiteUrl = (url) => {
        if (!url || url.trim() === '') {
            return true;
        }

        const trimmedUrl = url.trim().toLowerCase();
        const cleanUrl = trimmedUrl.replace(/^https?:\/\//, '').replace(/\/.*$/, '');

        if (!cleanUrl.includes('.')) {
            return false;
        }

        if (!/^[a-zA-Z0-9.-]+$/.test(cleanUrl)) {
            return false;
        }

        const parts = cleanUrl.split('.');
        if (parts.length < 2) {
            return false;
        }

        for (const part of parts) {
            if (part.length === 0) {
                return false;
            }
        }

        return true;
    };

    handleSelectChange = (field) => (selectedOption) => {
        let value = '';
        if (selectedOption) {
            if (typeof selectedOption === 'object' && selectedOption.value !== undefined) {
                value = selectedOption.value;
            } else if (typeof selectedOption === 'string') {
                value = selectedOption;
            }
        }

        this.setState({
            [field]: value
        });
    };

    handleDecimalInputChange = (fieldName) => (e) => {
        let value = e.target.value;

        if (value.startsWith('.')) {
            return;
        }

        if (value.startsWith('$')) {
            value = value.substring(1);
        }

        if (value === '') {
            this.setState({
                [fieldName]: ''
            });

            return;
        }

        value = value.replace(/[^0-9.]/g, '');

        const parts = value.split('.');

        if (parts.length > 2) {
            value = parts[0] + '.' + parts.slice(1).join('');
        }

        if (parts[1] && parts[1].length > 2) {
            value = parts[0] + '.' + parts[1].substring(0, 1);
        }

        this.setState({
            [fieldName]: value
        });
    };

    handleTicketSizeChange = this.handleDecimalInputChange('ticketSize');

    handleMonthlyVolumeChange = this.handleDecimalInputChange('expectedMonthlyVolume');

    handleYearsInBusinessChange = (e) => {
        const value = e.target.value;

        if (value === '') {
            this.setState({
                yearsInBusiness: ''
            });

            return;
        }

        const numValue = parseInt(value, 10);
        if (!isNaN(numValue) && numValue >= 0 && numValue <= 999) {
            this.setState({
                yearsInBusiness: value
            });
        }

    };

    handleTextareaFocus = (field) => () => {
        this.setState({
            [`${field}Focused`]: true
        });
    };

    handleTextareaBlur = (field) => () => {
        this.setState({
            [`${field}Focused`]: false
        });
    };

    hasFormChanged = () => {
        const { isEditMode } = this.props;

        if (!isEditMode || !this.initialFormState) {
            return true;
        }

        const formFields = [
            'legalBusinessName',
            'websiteUrl',
            'businessDescription',
            'expectedMonthlyVolume',
            'ticketSize',
            'fulfillmentTimeframe',
            'subscriptionRecurring',
            'yearsInBusiness',
            'additionalNotes'
        ];

        const hasFieldChanged = _.some(formFields, (field) =>
            String(this.state[field]) !== String(this.initialFormState[field])
        );

        if (hasFieldChanged) return true;

        const hasNewFiles = _.some(this.state.supportingDocuments, (file) =>
            file instanceof File || file instanceof Blob
        );

        if (hasNewFiles) return true;

        const initialDocCount = _.get(this.initialFormState, 'supportingDocuments.length', 0);
        if (this.state.supportingDocuments.length !== initialDocCount) return true;

        return false;
    };

    onDrop = (acceptedFiles, rejectedFiles) => {
        if (rejectedFiles.length > 0) {
            toast.error('Please ensure files are PDF format only.');

            return;
        }

        const currentFileCount = this.state.supportingDocuments.length;
        const totalFilesAfterAdd = currentFileCount + acceptedFiles.length;

        if (totalFilesAfterAdd > MAX_FILES_LIMIT) {
            const allowedFiles = MAX_FILES_LIMIT - currentFileCount;
            if (allowedFiles > 0) {
                acceptedFiles = acceptedFiles.slice(0, allowedFiles);
            } else {
                toast.error(`Maximum ${MAX_FILES_LIMIT} files allowed. Please remove some files before adding new ones.`);

                return;
            }
        }

        const oversizedFile = acceptedFiles.find((file) => file.size > MAX_FILE_SIZE_LIMIT);
        if (oversizedFile) {
            toast.error(`File "${oversizedFile.name}" exceeds the 4.5 MB limit. Total size for all files cannot exceed 4.5 MB.`);

            return;
        }

        const currentTotalSize = this.state.supportingDocuments.reduce((sum, file) => {
            return sum + (file.size || 0);
        }, 0);

        const newFilesSize = acceptedFiles.reduce((sum, file) => sum + file.size, 0);

        if (currentTotalSize + newFilesSize > MAX_FILE_SIZE_LIMIT) {
            toast.error('Total size for all files cannot exceed 4.5 MB.');

            return;
        }

        const normalizedFiles = acceptedFiles.map((file) => {
            file.documentName = file.name;

            return file;
        });

        this.setState((prevState) => ({
            supportingDocuments: [...prevState.supportingDocuments, ...normalizedFiles]
        }));
    };

    getFileDisplayName = (file) => {
        return file.documentName || file.name;
    };

    onOpenFileDialog = () => {
        if (this.dropzoneRef.current) {
            this.dropzoneRef.current.open();
        }
    };

    removeFile = (index) => {
        this.setState((prevState) => ({
            supportingDocuments: prevState.supportingDocuments.filter((_, i) => i !== index)
        }));
    };

    // data conversion function for backend schema compatibility
    convertValue = (value, type, options = {}) => {
        if (!value && value !== 0) return '';

        switch (type) {
            case 'decimal': {
                const numericValue = parseFloat(value);

                return isNaN(numericValue) ? null : numericValue;
            }

            case 'boolean':
                return value === 'yes';

            case 'integer': {
                const intValue = parseInt(value, 10);

                return isNaN(intValue) ? null : intValue;
            }

            case 'string':
            default:
                return value;
        }
    };

    handleSubmit = (e) => {
        if (e) {
            e.preventDefault();
        }

        if (!this.state.legalBusinessName || this.state.legalBusinessName.trim() === '') {
            toast.error('Please enter a legal business name');

            return;
        }

        if (!this.state.websiteUrl || this.state.websiteUrl.trim() === '') {
            toast.error('Please enter a website URL');

            return;
        }

        if (this.state.websiteUrl && !this.state.websiteUrlValid) {
            toast.error('Please enter a valid website URL (e.g., www.example.com or example.com)');

            return;
        }

        const filesToUpload = this.state.supportingDocuments.filter((file) => {
            return file && file.size && typeof file.size === 'number';
        });

        const totalFilesSize = filesToUpload.reduce((sum, file) => sum + file.size, 0);

        if (totalFilesSize > MAX_PAYLOAD_SIZE_LIMIT) {
            const sizeInMB = (totalFilesSize / 1048576).toFixed(2);
            const limitInMB = (MAX_PAYLOAD_SIZE_LIMIT / 1048576).toFixed(2);
            toast.error(`Total file size (${sizeInMB} MB) exceeds the maximum allowed payload size (${limitInMB} MB). Please reduce the file size or remove some files.`);

            return;
        }

        if (this.props.isEditMode) {
            this.props.onSubmitEditPrevetFormLoading();
            const formData = new FormData();

            formData.append('legalName', this.convertValue(this.state.legalBusinessName, 'string'));
            formData.append('webAddress', this.convertValue(this.state.websiteUrl, 'string'));
            formData.append('productsServicesOffered', this.convertValue(this.state.businessDescription, 'string'));
            formData.append('monthlyVolume', this.convertValue(this.state.expectedMonthlyVolume, 'decimal'));
            formData.append('averageSalesAmount', this.convertValue(this.state.ticketSize, 'decimal'));
            formData.append('fulfillmentPeriod', this.convertValue(this.state.fulfillmentTimeframe, 'string'));

            const doesRecurringBillingValue = this.convertValue(this.state.subscriptionRecurring, 'boolean');
            formData.append('doesRecurringBilling', doesRecurringBillingValue == null ? '' : doesRecurringBillingValue);
            formData.append('yearsInBusiness', this.convertValue(this.state.yearsInBusiness, 'integer'));
            // formData.append('hasBeenOnMatch', this.convertValue(this.state.hasBeenOnMatch, 'boolean'));
            formData.append('notes', this.convertValue(this.state.additionalNotes, 'string'));

            const filesToUpload = this.state.supportingDocuments.filter((file) => {
                return file instanceof File || file instanceof Blob;
            });

            if (filesToUpload.length > 0) {
                filesToUpload.forEach((file) => {
                    formData.append('files', file, file.name || file.documentName);
                });
                const allFilenames = filesToUpload.map((file) => file.name || file.documentName).join(', ');
                formData.append('processorStatement', allFilenames);
            } else {
                formData.append('processorStatement', '');
            }

            // Update Prevet with new data
            this.props.onSubmitEditPrevetForm(this.props.initialValues.id, formData);

        } else {
            this.props.onSubmitFormLoading();
            const formData = new FormData();

            formData.append('legalName', this.convertValue(this.state.legalBusinessName, 'string'));
            formData.append('webAddress', this.convertValue(this.state.websiteUrl, 'string'));
            formData.append('productsServicesOffered', this.convertValue(this.state.businessDescription, 'string'));
            formData.append('monthlyVolume', this.convertValue(this.state.expectedMonthlyVolume, 'decimal'));
            formData.append('averageSalesAmount', this.convertValue(this.state.ticketSize, 'decimal'));
            formData.append('fulfillmentPeriod', this.convertValue(this.state.fulfillmentTimeframe, 'string'));

            const doesRecurringBillingValue = this.convertValue(this.state.subscriptionRecurring, 'boolean');
            formData.append('doesRecurringBilling', doesRecurringBillingValue == null ? '' : doesRecurringBillingValue);
            formData.append('yearsInBusiness', this.convertValue(this.state.yearsInBusiness, 'integer'));
            // formData.append('hasBeenOnMatch', this.convertValue(this.state.hasBeenOnMatch, 'boolean'));
            formData.append('notes', this.convertValue(this.state.additionalNotes, 'string'));

            if (this.state.supportingDocuments.length > 0) {
                this.state.supportingDocuments.forEach((file) => {
                    formData.append('files', file, file.name);
                });
                const allFilenames = this.state.supportingDocuments.map((file) => file.name).join(', ');
                formData.append('processorStatement', allFilenames);
            } else {
                formData.append('processorStatement', '');
            }

            this.props.onSubmitForm(formData);
        }
    };

    renderSupportingDocuments = () => {
        const { supportingDocuments } = this.state;

        return (
            <div className="supporting-documents">
                <div className="field-label">
                    ADD FINANCIAL, PROCESSING AND BANK STATEMENTS HERE
                </div>
                <Dropzone
                    accept="application/pdf"
                    className="file-upload-container"
                    disableClick
                    multiple
                    onDrop={this.onDrop}
                    ref={this.dropzoneRef}
                >
                    <div className="file-upload-content">
                        <div className="file-upload-text">
                            Drag files here to upload
                        </div>
                        <div className="file-upload-or">
                            or
                        </div>
                        <Button
                            className="file-upload-button"
                            type="button"
                            onClick={this.onOpenFileDialog}
                        >
                            Browse File
                        </Button>
                    </div>
                </Dropzone>
                <div className="file-upload-caption">
                    Accepted file format: PDF only
                </div>

                {supportingDocuments.length > 0 && (
                    <div className="uploaded-files">
                        {supportingDocuments.map((file, index) => (
                            <div key={`${file.name || file.documentName}-${file.size}`} className="uploaded-file">
                                <span className="file-name">
                                    {this.getFileDisplayName(file)}
                                </span>
                                <button
                                    type="button"
                                    className="remove-file"
                                    onClick={() => this.removeFile(index)}
                                >
                                    ×
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    renderLoadingView = () => {
        return (
            <div className="loading-view">
                <div className="loading-content">
                    <div className="loading-spinner">
                        <LoadingSpinner />
                    </div>
                    <p className="loading-message">
                        Evaluating business. This may take a few minutes...
                    </p>
                </div>
            </div>
        );
    };

    renderFormContent() {
        const {
            legalBusinessName,
            websiteUrl,
            businessDescription,
            expectedMonthlyVolume,
            ticketSize,
            fulfillmentTimeframe,
            subscriptionRecurring,
            yearsInBusiness,
            // hasBeenOnMatch,
            additionalNotes,
            businessDescriptionFocused,
            additionalNotesFocused,
            websiteUrlValid
        } = this.state;

        const { isSubmitting } = this.props;

        // Show loading view when submitting (create or edit mode)
        if (isSubmitting || this.isPolling) {
            return this.renderLoadingView();
        }

        return (
            <>
                <div className="form-description">
                    The more information that is filled out, the more accurate our estimator will be.
                </div>

                <EmvioValidatedForm onSubmit={this.handleSubmit} className="pre-vet-form-content">
                    <div className="form-fields">
                        <EmvioValidatedInput
                            labelText="LEGAL BUSINESS NAME (Required)"
                            name="legalBusinessName"
                            onChange={this.handleInputChange('legalBusinessName')}
                            placeholder="Legal Business Name"
                            type="text"
                            validations={['required']}
                            value={legalBusinessName}
                            shouldNotTrim={true}
                        />

                        <EmvioValidatedInput
                            className={websiteUrl && !websiteUrlValid ? 'url-invalid' : ''}
                            labelText="WEBSITE URL (Required)"
                            name="websiteUrl"
                            onChange={this.handleWebsiteUrlChange}
                            placeholder="www.yourbusiness.com"
                            type="text"
                            validations={['required']}
                            value={websiteUrl}
                        />
                        {websiteUrl && !websiteUrlValid && (
                            <div className="validation-error">
                                Please enter a valid website URL (e.g., www.example.com or example.com)
                            </div>
                        )}

                        <EmvioValidatedTextArea
                            labelText="DESCRIPTION OF PRODUCTS AND SERVICES OFFERED"
                            name="businessDescription"
                            onChange={this.handleInputChange('businessDescription')}
                            onFocus={this.handleTextareaFocus('businessDescription')}
                            onBlur={this.handleTextareaBlur('businessDescription')}
                            placeholder={!businessDescriptionFocused ? 'Clearly describe the products and/or services your business sells and what you will accept credit card payments for. Be specific.' : ''}
                            rows={4}
                            value={businessDescription}
                        />

                        <EmvioValidatedInput
                            labelText="EXPECTED MONTHLY VOLUME"
                            name="expectedMonthlyVolume"
                            onChange={this.handleMonthlyVolumeChange}
                            placeholder="$0.00"
                            type="text"
                            value={expectedMonthlyVolume ? `$${expectedMonthlyVolume}` : ''}
                            shouldEnforceNumber={true}
                        />

                        <EmvioValidatedInput
                            labelText="TICKET SIZE"
                            name="ticketSize"
                            onChange={this.handleTicketSizeChange}
                            placeholder="$0.00"
                            type="text"
                            value={ticketSize ? `$${ticketSize}` : ''}
                            shouldEnforceNumber={true}
                        />

                        <div className="form-field dropdown-field">
                            <div className="field-label">
                                FULFILLMENT TIMEFRAME
                                <span className="info-icon" title="Days between payment received and goods/services delivered">
                                    <img alt="Info" src={imgInfoIcon} />
                                </span>
                            </div>
                            <EmvioSelect
                                key={`fulfillmentTimeframe-${fulfillmentTimeframe || ''}`}
                                name="fulfillmentTimeframe"
                                onChange={this.handleSelectChange('fulfillmentTimeframe')}
                                options={FULFILLMENT_TIMEFRAME_OPTIONS}
                                defaultSelectedOption={FULFILLMENT_TIMEFRAME_OPTIONS.find((option) => option.value === fulfillmentTimeframe) || null}
                            />
                        </div>

                        <div className="form-field dropdown-field">
                            <div className="field-label">SUBSCRIPTION/RECURRING?</div>
                            <EmvioSelect
                                key={`subscriptionRecurring-${subscriptionRecurring || ''}`}
                                name="subscriptionRecurring"
                                onChange={this.handleSelectChange('subscriptionRecurring')}
                                options={SUBSCRIPTION_OPTIONS}
                                defaultSelectedOption={SUBSCRIPTION_OPTIONS.find((option) => option.value === subscriptionRecurring) || null}
                            />
                        </div>

                        <EmvioValidatedInput
                            labelText="YEARS IN BUSINESS"
                            name="yearsInBusiness"
                            onChange={this.handleYearsInBusinessChange}
                            placeholder="00"
                            type="text"
                            value={yearsInBusiness}
                            shouldEnforceInt={true}
                            maxLength={3}
                        />

                        {/* // comment out hasBeenOnMatch field since it was added after the initial design and the backend is not updated for it yet */}
                        {/* {this.props.isEditMode && (
                            <div className="form-field dropdown-field">
                                <div className="field-label">HAS THE BUSINESS OR THE OWNER(S) BEEN ON MATCH?</div>
                                <EmvioSelect
                                    key={`hasBeenOnMatch-${hasBeenOnMatch || 'empty'}`}
                                    label=""
                                    name="hasBeenOnMatch"
                                    onChange={this.handleSelectChange('hasBeenOnMatch')}
                                    options={YES_NO_OPTIONS}
                                    defaultSelectedOption={YES_NO_OPTIONS.find((option) => option.value === hasBeenOnMatch) || null}
                                />
                            </div>
                        )} */}

                        {this.renderSupportingDocuments()}

                        <EmvioValidatedTextArea
                            labelText="ADDITIONAL NOTES"
                            name="additionalNotes"
                            onChange={this.handleInputChange('additionalNotes')}
                            onFocus={this.handleTextareaFocus('additionalNotes')}
                            onBlur={this.handleTextareaBlur('additionalNotes')}
                            placeholder={!additionalNotesFocused ? 'Notes here' : ''}
                            rows={4}
                            value={additionalNotes}
                        />
                    </div>

                    <div className="form-actions">
                        <EmvioButton
                            className="submit-button"
                            invertColors={true}
                            isLoading={isSubmitting}
                            disabled={this.props.isEditMode && !this.hasFormChanged()}
                            type="submit"
                        >
                            Submit
                        </EmvioButton>
                    </div>
                </EmvioValidatedForm>
            </>
        );
    }

    render() {
        const { showInModal, uniqueModalName, modalTitle, submitSuccess, isEditMode } = this.props;

        if (showInModal) {
            return (
                <Modal
                    uniqueModalName={uniqueModalName}
                    title={(submitSuccess && !isEditMode) ? '' : modalTitle}
                    onOpen={this.handleModalOpen}
                    forceOpen={(submitSuccess && !isEditMode) || (submitSuccess && isEditMode && this.isPolling)}
                >
                    {this.renderFormContent()}
                </Modal>
            );
        }

        return this.renderFormContent();
    }
}

function mapStateToProps(state, ownProps) {
    if (ownProps.isEditMode) {
        return {
            isSubmitting: getIsPrevetFormUpdateLoading(state),
            error: getPrevetFormUpdateError(state),
            submitSuccess: getIsPrevetFormUpdateSuccess(state),
            updatedPrevetId: getPrevetFormUpdatePrevetId(state),
            prevet: getPrevetEntity(state)?.prevet
        };
    }

    return {
        isSubmitting: getIsPrevetFormSubmitting(state),
        error: getPrevetFormError(state),
        submitSuccess: getPrevetFormSubmitSuccess(state),
        prevetId: getPrevetFormPrevetId(state),
        prevet: getPrevetEntity(state)?.prevet
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onSubmitForm: (formData) => dispatch(submitPrevetForm(formData)),
        onSubmitEditPrevetForm: (EditPrevetId, formData) => dispatch(onSubmitEditPrevetForm(EditPrevetId, formData)),
        onSubmitEditPrevetFormLoading: () => dispatch(updatePrevetFormLoading()),
        onSubmitFormLoading: () => dispatch(submitPrevetFormLoading()),
        onToggleModal: (modalName) => dispatch(toggleModal(modalName)),
        onResetForm: () => dispatch(resetPrevetForm()),
        onFetchPrevet: (prevetId) => dispatch(fetchPrevet(prevetId))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrevetForm));
